export default "__VITE_ASSET__B4rfA5yu__"